module.exports = __webpack_public_path__ + "media/inserate/assets/images/web-d226973d953dcf454400132cd2362d94.png";